import { CHANGE_TYPES } from './change-formatter'

/**
 * Detects the type of change based on field name and values
 */
export function detectChangeType (fieldName, oldValue, newValue) {
  // Demografia (JSON string)
  if (fieldName === 'demographics') {
    return CHANGE_TYPES.DEMOGRAPHICS
  }

  // Qualquer valor que seja objeto (incluindo null) deve ser tratado como object_modification
  if (typeof oldValue === 'object' || typeof newValue === 'object') {
    return CHANGE_TYPES.OBJECT_MODIFICATION
  }

  // Status change
  if (fieldName === 'status') {
    return CHANGE_TYPES.STATUS_CHANGE
  }

  // Valores monetários
  if (isMonetaryField(fieldName)) {
    return CHANGE_TYPES.MONETARY
  }

  // Datas
  if (fieldName.includes('date')) {
    return CHANGE_TYPES.DATE
  }

  // Booleano
  if (typeof oldValue === 'boolean' || typeof newValue === 'boolean') {
    return CHANGE_TYPES.BOOLEAN
  }

  // Arrays
  if (Array.isArray(oldValue) || Array.isArray(newValue)) {
    return CHANGE_TYPES.ARRAY
  }

  // Texto simples
  return CHANGE_TYPES.SIMPLE
}

/**
 * Checks if field is monetary
 */
function isMonetaryField (fieldName) {
  const monetaryFields = ['budget', 'amount', 'bid', 'cpm', 'cpc']
  return monetaryFields.some(field => fieldName.includes(field))
}

/**
 * Extracts a meaningful name from an object
 */
export function extractObjectName (obj) {
  if (!obj || typeof obj !== 'object') {
    return 'N/A'
  }

  return obj.name ||
         obj.title ||
         obj.label ||
         obj.id ||
         obj.uuid?.substring(0, 8) ||
         'Item'
}

/**
 * Formats simple values for display
 */
export function formatSimpleValue (value) {
  if (value === null || value === undefined) {
    return 'N/A'
  }

  if (typeof value === 'object') {
    return extractObjectName(value)
  }

  if (typeof value === 'string' && value.length > 30) {
    return value.substring(0, 27) + '...'
  }

  return String(value)
}
